var $3ad4dfd69f313220$exports = {};
$3ad4dfd69f313220$exports = {
  "backButton": args => "Voltar ao ".concat(args.prevMenuButton),
  "moreActions": "Mais a\xE7\xF5es",
  "unavailable": "Indispon\xEDvel, expandir para mais detalhes"
};
export { $3ad4dfd69f313220$exports as default };